// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2kN-k","subheader":"ReorderModal_subheader__1TH1X","listWrap":"ReorderModal_listWrap__2Ult_"};